import * as commonHashes from './persisted_common.json';
import * as subsHashes from './persisted_subs.json';
import * as userHashes from './persisted_user.json';

const hashes = { ...commonHashes, ...userHashes, ...subsHashes };

export default hashes;
